module.exports = __webpack_public_path__ + "img/img.0930c44a.png";